export default (value = '') => value.length;



// WEBPACK FOOTER //
// ./sources/filters/size.js